import { compose } from 'redux';
import { connect } from 'react-redux';
import React from 'react';
import { FieldArray, Form, getFormValues, reduxForm } from 'redux-form';
import SmsConfirmationMessageForm from '../SchemeManagementForms/SmsConfirmationMessageForm/SmsConfirmationMessageForm';
import { Box, Button } from '../../../../common/components';
import { Col, Row } from 'react-bootstrap';
import { UpdateSchemesFieldArray } from '../SchemesToUpdateFieldArray/SchemesToUpdateFieldArray';

const FORM_NAME = 'InsurerHandlerForm';

const InsurerSmsConfirmationMessageForm = ({
  submitting,
  handleSubmit,
  onUpdate,
  formName,
}) => {
  return (
    <Box>
      <Form horizontal onSubmit={handleSubmit(onUpdate)}>
        <SmsConfirmationMessageForm
          isViewOnly={false}
          formName={formName}
          title={'Single Reference Sms Message'}
        />
        <FieldArray name={'meta.schemes'} component={UpdateSchemesFieldArray} />
        <Row>
          <Col sm={12}>
            <Button
              bsStyle="primary"
              className="pull-right margin-top"
              isLoading={submitting}
              type="submit"
            >
              Save Changes
            </Button>
          </Col>
        </Row>
      </Form>
    </Box>
  );
};

export default compose(
  connect((state, props) => {
    return {
      formValues: getFormValues(props.formName)(state),
      initialValues: props.values,
      form: props.formName,
    };
  }),
  reduxForm({
    form: FORM_NAME,
  }),
)(InsurerSmsConfirmationMessageForm);
